var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconXls(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 10.6091V32.3926C31.5 33.0076 31.0059 33.5 30.4036 33.5H9.27957C8.6773 33.5 8.18317 33.0076 8.18317 32.3926V3.60762C8.18317 2.99259 8.6774 2.5 9.27957 2.5H22.885L31.5 10.6091Z",
    fill: "white",
    stroke: "#A6A6A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.36511 29.1231L7.68305 31.5307L7.66533 28.7529L4.36511 29.1231Z",
    fill: "#207720"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.89076 16.5986H25.3161C25.8075 16.5986 26.2069 17.0657 26.2069 17.6413V28.2085C26.2069 28.7838 25.8079 29.2512 25.3161 29.2512H4.89076C4.39934 29.2512 4 28.7842 4 28.2085V17.6413C4 17.0661 4.39898 16.5986 4.89076 16.5986Z",
    fill: "#3AB63B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32 10.3931V10.6416H24.0561C23.4498 10.6416 22.9578 10.1463 22.9578 9.5355V2H23.0832L32 10.3931Z",
    fill: "#A6A6A6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5151 7.83984H10.202V9.15168H20.5151V7.83984Z",
    fill: "#E6E6E6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5151 10.2217H10.202V11.5335H20.5151V10.2217Z",
    fill: "#E6E6E6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5151 12.6035H10.202V13.9154H20.5151V12.6035Z",
    fill: "#E6E6E6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.66016 19.9902L8.88867 22.0571H8.93018L10.167 19.9902H11.5781L9.74365 22.9951L11.6196 26H10.1753L8.93018 23.9331H8.88867L7.64355 26H6.20752L8.0918 22.9951L6.24072 19.9902H7.66016ZM12.3335 26V19.9902H13.5786V24.9707H16.1685V26H12.3335ZM20.2358 21.7085C20.186 21.2312 19.8083 20.9531 19.1982 20.9531C18.5674 20.9531 18.2146 21.2437 18.2104 21.6421C18.2063 22.0779 18.6545 22.2729 19.1733 22.3892L19.7129 22.522C20.7422 22.7585 21.51 23.2815 21.5142 24.2817C21.51 25.3816 20.655 26.0872 19.1899 26.083C17.7373 26.0872 16.8118 25.4148 16.7744 24.124H17.9863C18.0278 24.73 18.5093 25.0371 19.1733 25.0371C19.8291 25.0371 20.2524 24.73 20.2524 24.2817C20.2524 23.8708 19.8789 23.6799 19.2231 23.5181L18.5674 23.3604C17.5547 23.1113 16.9321 22.605 16.9321 21.7251C16.928 20.6335 17.8909 19.9072 19.2065 19.9072C20.5388 19.9072 21.4146 20.646 21.4312 21.7085H20.2358Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconXls);
export default __webpack_public_path__ + "static/media/icon-xls.86ddec504674f809990d7e9eaacf2695.svg";
export { ForwardRef as ReactComponent };